"use strict";

module.exports = /* @ngInject */ function ErrorMessageController(
  openFinApi,
  windowTitle,
  $location
) {
  var that = this;

  that.message =
    $location.search().message ||
    "An error was encountered loading this screen. Please close the window and try again. If the problem persists, please contact support.";

  that.close = function() {
    openFinApi.getFin().then(fin => {
      const force = false;
      fin.desktop.Window.getCurrent().close(force);
    });
  };

  (function() {
    windowTitle.set($location.search().title || "Error");
  })();
};



// WEBPACK FOOTER //
// ./app/presentation/controllers/ErrorMessageController.js